"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.replaceStore = void 0;
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const store_1 = require("@completeanatomy/store");
const sync_service_1 = require("@completeanatomy/sync-service");
const typedi_1 = require("typedi");
/**
 * Replaces CAStore in DI Container
 *
 * @param store - store to inject
 */
function replaceStore(store) {
    // @ts-ignore
    const bridge = typedi_1.Container.get(bridge_schema_1.BridgeInterface);
    typedi_1.Container.reset();
    typedi_1.Container.set(store_1.StoreToken, store);
    typedi_1.Container.set(bridge_schema_1.BridgeInterface, bridge);
    typedi_1.Container.set({ id: sync_service_1.SyncService, type: sync_service_1.SyncService, eager: true });
}
exports.replaceStore = replaceStore;
